import { secureGet } from '../utils/HttpUtils';

export interface RiskAnalystDto {
  id: number;
  firstName: string;
  lastName: string;
  label: string;
}

export const getRiskAnalysts = async () => {
  return secureGet('/v1/private/risk-analysts');
};
